import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';
import { UtilityService } from '../../../core/services/utility.service';

@Component({
  selector: 'tt-consignment-colli-detail',
  templateUrl: './consignment-colli-detail.component.html',
  styleUrls: ['./consignment-colli-detail.component.css']
})
export class ConsignmentColliDetailComponent implements OnInit {
    consignmentColliKeyno;

    public caseButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'case', gotoParms: () => this.edit!.case_keyno ?? '' }];

    public selectedBgConsignmentColliDetail: string = 'BASIS';

    public edit?: Edit;

    public itemsListDetails: Item[] = [];

    public grid?: GridOptions;

    public saving = false;

    constructor(private stateService: StateService, private utility: UtilityService, private modal: ModalService, private datatask: DataTaskService) {
        this.consignmentColliKeyno = this.stateService.getStateParams()['consignmentcolli_keyno'];
    }

    private async loadEdit() {
        if (!!this.consignmentColliKeyno) {
            this.edit = (await this.datatask.Post(1427, { consignmentcolli_keyno: this.consignmentColliKeyno }))[0];
        }
    }

    private async loadDetails() {
        if (!this.edit) return;

        return this.itemsListDetails = await this.datatask.Post(2654, { consignmentcolli_keyno: this.edit.consignmentcolli_keyno });
    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid().setRememberId('w_consignmentcollidetail_carriers_grid').setLoadDataFunction({ method: 2668, parameters: () => this.edit }).setKendoConfig({ height: '100%' }).setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public async saveItemsChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;
                
                const mergeObj = {
                    ...this.edit,
                    records: this.itemsListDetails
                }

                const response = (await this.datatask.Post(1429, mergeObj))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.go('consignment', { consignment_keyno: this.edit.consignment_keyno });
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async saveGridChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;
               
                const selectedItems = (this.grid?.gridfunc?.getAllRows() ?? []).map((row) => ({
                    carrier_keyno: row['carrier_keyno'],
                    quantity: row['quantity'],
                    consignmentcarrier_keyno: row['consignmentcarrier_keyno']
                }));

                const mergeObj = {
                    ...this.edit,
                    records: selectedItems
                }

                const response = (await this.datatask.Post(1429, mergeObj))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.go('consignment', { consignment_keyno: this.edit.consignment_keyno });
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async recalcVolume() {
        if (!!this.edit) {
            this.edit.volume = (this.utility.parseNumber(this.edit.length) * this.utility.parseNumber(this.edit.width) * this.utility.parseNumber(this.edit.height)) as number / 1000000;
        }
    }

    public onChanged(_: string | number, id: keyof Edit) {
        if (!this.edit) return;

        switch (id) {
            case 'length':
            case 'width':
            case 'height':
                this.recalcVolume();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadDetails();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    consignment_keyno: string;
    consignmentcolli_keyno: string;
    colli_sscc: string;
    weight: string;
    volume: string | number;
    length: string | number;
    width: string | number;
    height: string | number;
    description: string;
    case_keyno: string;
}
